module.exports = __webpack_public_path__ + "static/media/alert_error.7242e468.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/alert_error.svg
// module id = 817
// module chunks = 0